import { Col, Row, Modal, Form, Switch, Select, message } from "antd";
import { useTranslation } from "react-i18next";
import { UseMutateAsyncFunction, useMutation } from "react-query";
import { ItemUnitType } from "./unitType";
import { Dispatch, useEffect, useState } from "react";
import { editItemUnit, createItemUnit } from "../../../api/itemUnit";
import Title from "../../UI/Title/Title";
import AddEditModal from "../../UI/ModalComponent/AddEditModal/addeditcomponent";
import { AxiosResponse } from "axios";
import InputName from "../../UI/InputNumberComponent/InputName";

type propsType = {
  Unit?: ItemUnitType | undefined;
  openUnit: boolean;
  id?: string | number;
  setOpenUnit: React.Dispatch<React.SetStateAction<boolean>>;
  loadingItem: boolean;
  ItemUnitMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      limit: number;
      q: string;
      isActive?: boolean | undefined;
    },
    unknown
  >;
  formatedItem: { value: string; label: string }[] | undefined;
  setPaginatedItemUnit: Dispatch<any>;
  filter: boolean | undefined;
  search: string;
};
export const AddEditItemUnit = ({
  Unit,
  openUnit,
  setOpenUnit,
  id,
  formatedItem,
  loadingItem,
  search,
  filter,
  ItemUnitMutation,
  setPaginatedItemUnit,
}: propsType) => {
  const [t] = useTranslation("common");
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();
  const [, setError] = useState("");
  const isEdit = () => {
    return !!id;
  };
  const [editStatus] = useState(isEdit());
  const [isActive, setIsActive] = useState<boolean>(
    Unit ? Unit?.isActive : true
  );
  const [selectedItemType, setSelectedItemType] = useState<any>(null);
  const [unitName, setUnitName] = useState(false);
  useEffect(() => {
    if (editStatus) {
      setUnitName(true);
      setSelectedItemType(true);
    }
  }, [editStatus]);

  const handleNameChange = (value: any) => {
    setUnitName(value);
  };
  const onError = (error: any, variables: ItemUnitType, context: unknown) => {
    if (setError) {
      setError(error.response.data.message);
      message.error({
        content: error.response.data.message,
        duration: 10,
        onClick: () => {
          message.destroy();
        },
      });
    }
  };

  const { mutate: mutateCreateUpdate, isLoading: isSaving } = useMutation(
    !isEdit() ? "createItemUnit" : "editItemUnit",
    !isEdit()
      ? (unit: ItemUnitType) => createItemUnit(unit)
      : (unit: ItemUnitType) => editItemUnit(id, unit),
    {
      onSuccess: (res) => {
        setOpen(false);
        setOpenUnit(false);
        message.success("Complete successfully");
        ItemUnitMutation({
          q: search,
          limit: 0,
          isActive: filter,
        }).then((res: any) => {
          setPaginatedItemUnit(res.data);
        });
      },
      onError,
    }
  );

  const handleFinish = () => {
    const newitemunit = form.getFieldsValue();
    for (const key in newitemunit) {
      if (newitemunit[key] === undefined) {
        if (key === "isActive") {
          newitemunit[key] = true;
        } else {
          newitemunit[key] = null;
        }
      } else if (
        typeof newitemunit[key] === "string" &&
        newitemunit[key].trim() === ""
      ) {
        newitemunit[key] = null;
      }
    }
    mutateCreateUpdate(newitemunit);
    form.resetFields();
  };
  useEffect(() => {
    if (Unit && Unit.itemType) {
      form.setFieldsValue({
        itemTypeId: Unit.itemType.id,
        name: Unit?.name,
        abbreviation: Unit?.abbreviation,
      });
    }
  }, [form, Unit]);

  const handleCancel = () => {
    form.resetFields();
    setSelectedItemType(null);
    setUnitName(false);
  };

  return (
    <>
      <Modal
        closable={false}
        maskClosable={false}
        width={490}
        centered
        open={openUnit}
        onCancel={() => {
          setOpenUnit(false);
          handleCancel();
        }}
        cancelText={t("cancel")}
        okButtonProps={{
          style: {
            height: "40px",
            background: "#1677FF",
            color: "#fff",
            width: "100px",
          },
          disabled: !unitName || !selectedItemType,
        }}
        cancelButtonProps={{
          style: {
            color: "#1677FF",
            border: "1px solid #1677FF",
            height: "40px",
            width: "100px",
          },
        }}
        okText={isEdit() ? `${t("save")}` : `${t("add")}`}
        onOk={() => {
          setOpen(true);
        }}
      >
        <Col offset={1}>
          {" "}
          <Title
            title={
              isEdit() ? `${t("edit-item-unit")}` : `${t("add-item-unit")}`
            }
          />
        </Col>
        {isEdit() && (
          <span className="modaltitleEdit">
            <Col offset={1}>
              {" "}
              {t("edit-details-for")} {Unit?.name}
            </Col>
          </span>
        )}
        <Form
          layout="vertical"
          form={form}
          className="no-hover-label"
          id="UnitForm"
          onFinish={handleFinish}
        >
          <Row>
            <Col span={14} offset={1} style={{ marginTop: "20px" }}>
              <Form.Item
                name="itemTypeId"
                label={t("item-type")}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  data-testid="currency"
                  loading={loadingItem}
                  options={formatedItem}
                  placeholder={`${t("select-item")}`}
                  showSearch={true}
                  optionFilterProp="label"
                  onChange={(value: any) => setSelectedItemType(value)}
                />
              </Form.Item>

              <Form.Item
                name="name"
                label={t("unit-name")}
                rules={[
                  {
                    required: true,
                    message: "unit name is required",
                  },
                ]}
              >
                <InputName onChange={handleNameChange} maxLength={50} />
              </Form.Item>

              <Form.Item name="abbreviation" label={t("abbreviation")}>
                <InputName maxLength={10} />
              </Form.Item>

              <Form.Item name="isActive" label={`${t("status")}`}>
                <Switch
                  checkedChildren={`${t("active")}`}
                  unCheckedChildren={`${t("inactive")}`}
                  checked={isActive}
                  disabled={isEdit() ? false : true}
                  onChange={(num: boolean) => {
                    setIsActive(num);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <AddEditModal
        form="UnitForm"
        open={open}
        setOpen={setOpen}
        name={<span>{Unit?.name}</span>}
        title={`${t("modal-item-unit")}`}
        id={id}
        isSaving={isSaving}
      />
    </>
  );
};
